import { IOepnvData } from "@types"
import { protectedApi } from "store/Api"

const ptDataApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchPtData: builder.query<IOepnvData[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `data/pt_data`,
                }
            },
        }),
    }),
})

export const { useFetchPtDataQuery } = ptDataApi
